export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7175.5e74ef8b.jpg";